import { colors } from '../../colors';
var blogList = {
  borderColor: colors.overcast,
  bgColor: colors.white,
  breadcrumbColor: colors.dirtyBlue,
  subHeadingColor: colors.dirtyBlue,
  headingColor: colors.black,
  paraColor: colors.black,
  filterTextColor: colors.black
};
export default blogList;